import { HostListener, OnDestroy } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalizeRouterService } from 'localize-router';
import { fromEvent, Subscription } from 'rxjs';
import { AuthService } from '../../_services/auth.sevice';
import { CarrelloService } from '../../_services/carrello.service';
import { HeaderService } from '../../_services/header.service';
import { StorageService } from '../../_services/storage.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styles: [],
  host: {'class': 'menu-sticky sticky-top'}
})
export class MenuComponent implements OnInit, OnDestroy {

  constructor(
    private storage: StorageService,
    private header: HeaderService,
    private auth: AuthService,
    private router: Router,
    private carrelloService: CarrelloService,
    private localize: LocalizeRouterService) { }

  subs: Subscription[] = [];

  menu = [];
  menuSecondario = [];
  scrolled = false;
  showMobileMenu = false;
  totaleCarrello = 0;

  termineRicerca = '';
  showHeaderSecondario = false;

  ngOnInit() {
    this.aggiornaTotaleCarrello();
    this.subs = [
      fromEvent(window, 'scroll').subscribe(() => this.onScroll()),
      this.header.aggiornaCarrello.subscribe(() => this.aggiornaTotaleCarrello() ),
      this.header.setHeaderSecondario.subscribe((headerSecondario) => this.showHeaderSecondario = headerSecondario)
    ];
    this.storage.getMapponeInLingua().subscribe(mappone => {
      this.menu = mappone.menuHeader;
      this.menuSecondario = mappone.menuHeaderSecondario;
      // this.menu[0].figli[1].figli = [JSON.parse(JSON.stringify(this.menu[1].figli[0]))];
    });
  }

  ngOnDestroy(): void {
  }

  onScroll() {
    this.scrolled = window.scrollY > 60;
  }

  aggiornaTotaleCarrello() {
    this.totaleCarrello = 0;
    this.carrelloService.getProdotti().subscribe(prodotti => prodotti.forEach(p => this.totaleCarrello += p.quantita));
  }

  logout() {
    this.auth.logout().subscribe(() => this.router.navigate([this.localize.translateRoute('/').toString()]));
  }

  accedi() {
    this.router.navigate([this.localize.translateRoute('/login').toString()], {queryParams: { returnUrl: window.location.href }}).then(() => this.showMobileMenu = false);
  }

  get logged() {
    return this.auth.isLogged;
  }

  get user() {
    return this.auth.user;
  }

  cerca() {
    if (this.termineRicerca) {
      this.router.navigate([this.localize.translateRoute('/ricerca-generica')], { queryParams: { q: this.termineRicerca } }).then(() => this.showMobileMenu = false);
    }
  }

  voceFiglioClicked(voce, voceFiglio) {
    const wasOpen = voceFiglio.open;
    voce.figli.forEach(v => v.open = false);
    if (!wasOpen) { voceFiglio.open = true; }
  }

}
